module.exports = __webpack_public_path__ + "img/minpian1.62ccac72.jpg";